module.exports = __webpack_public_path__ + "static/b5-a07276ff4c2d311b3b6d6a8c2bc2ca3e.jpg";